<template>
  <div class="signup-login-wrapper">
    <div class="logo-wrapper">
      <a href="/">
        <GkLogoAnim theme="white" />
      </a>
    </div>
    <div class="ratings-wrap">
      <h2>
        {{ $gettextInterpolate(sloganText, { num: '180,000' }) }}
      </h2>
      <div class="ratings-container">
        <div style="display: flex; align-items: center; gap: 4px; justify-content: center;">
          <div style="display: flex; align-items: flex-end; gap: 4px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 576 512"><path d="M381.2 150.3L524.9 171.5C536.8 173.2 546.8 181.6 550.6 193.1C554.4 204.7 551.3 217.3 542.7 225.9L438.5 328.1L463.1 474.7C465.1 486.7 460.2 498.9 450.2 506C440.3 513.1 427.2 514 416.5 508.3L288.1 439.8L159.8 508.3C149 514 135.9 513.1 126 506C116.1 498.9 111.1 486.7 113.2 474.7L137.8 328.1L33.58 225.9C24.97 217.3 21.91 204.7 25.69 193.1C29.46 181.6 39.43 173.2 51.42 171.5L195 150.3L259.4 17.97C264.7 6.954 275.9-.0391 288.1-.0391C300.4-.0391 311.6 6.954 316.9 17.97L381.2 150.3z" fill="#f4b840"/></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 576 512"><path d="M381.2 150.3L524.9 171.5C536.8 173.2 546.8 181.6 550.6 193.1C554.4 204.7 551.3 217.3 542.7 225.9L438.5 328.1L463.1 474.7C465.1 486.7 460.2 498.9 450.2 506C440.3 513.1 427.2 514 416.5 508.3L288.1 439.8L159.8 508.3C149 514 135.9 513.1 126 506C116.1 498.9 111.1 486.7 113.2 474.7L137.8 328.1L33.58 225.9C24.97 217.3 21.91 204.7 25.69 193.1C29.46 181.6 39.43 173.2 51.42 171.5L195 150.3L259.4 17.97C264.7 6.954 275.9-.0391 288.1-.0391C300.4-.0391 311.6 6.954 316.9 17.97L381.2 150.3z" fill="#f4b840"/></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 576 512"><path d="M381.2 150.3L524.9 171.5C536.8 173.2 546.8 181.6 550.6 193.1C554.4 204.7 551.3 217.3 542.7 225.9L438.5 328.1L463.1 474.7C465.1 486.7 460.2 498.9 450.2 506C440.3 513.1 427.2 514 416.5 508.3L288.1 439.8L159.8 508.3C149 514 135.9 513.1 126 506C116.1 498.9 111.1 486.7 113.2 474.7L137.8 328.1L33.58 225.9C24.97 217.3 21.91 204.7 25.69 193.1C29.46 181.6 39.43 173.2 51.42 171.5L195 150.3L259.4 17.97C264.7 6.954 275.9-.0391 288.1-.0391C300.4-.0391 311.6 6.954 316.9 17.97L381.2 150.3z" fill="#f4b840"/></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 576 512"><path d="M381.2 150.3L524.9 171.5C536.8 173.2 546.8 181.6 550.6 193.1C554.4 204.7 551.3 217.3 542.7 225.9L438.5 328.1L463.1 474.7C465.1 486.7 460.2 498.9 450.2 506C440.3 513.1 427.2 514 416.5 508.3L288.1 439.8L159.8 508.3C149 514 135.9 513.1 126 506C116.1 498.9 111.1 486.7 113.2 474.7L137.8 328.1L33.58 225.9C24.97 217.3 21.91 204.7 25.69 193.1C29.46 181.6 39.43 173.2 51.42 171.5L195 150.3L259.4 17.97C264.7 6.954 275.9-.0391 288.1-.0391C300.4-.0391 311.6 6.954 316.9 17.97L381.2 150.3z" fill="#f4b840"/></svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 576 512"><path d="M288 439.8L159.8 508.3C149 514 135.9 513.1 126 506C116.1 498.9 111.1 486.7 113.2 474.7L137.8 328.1L33.58 225.9C24.97 217.3 21.91 204.7 25.69 193.1C29.46 181.6 39.43 173.2 51.42 171.5L195 150.3L259.4 17.97C264.7 6.995 275.8 .0131 287.1-.0391L288 439.8zM433.2 512C432.1 512.1 431 512.1 429.9 512H433.2z" fill="#f4b840"/></svg>
          </div>
          <div class="rating-number" style="display:flex; align-items: flex-end; color: #f4b840;"><span style="line-height: 1;">9.3</span></div>
        </div>
      </div>
      <div class="ratings-footer" v-html="$gettextInterpolate(sloganSubtext, { num: '782' })" />
    </div>
    <div class="signup-login-form-wrap">
      <transition name="fade" appear mode="out-in">
        <SignupFormSimple
          v-if="formType === 'signup'"
          :key="mainTransitionKey"
          @authorised="$emit('authorised', false)"
          :remember-email="rememberEmail"
          @remember-email="(email) => { rememberEmail = email }"
          @show-country="formType = 'country'"
        />
        <SignupCountryForm
          v-if="formType === 'country'"
          :key="mainTransitionKey"
          @authorised="$emit('authorised', false)"
        />
      </transition>
    </div>
    <transition name="fade-delayed" appear mode="out-in">
      <div class="security">
        <div class="secure-online">
          <font-awesome-icon icon="fa-solid fa-shield-check" />
          <div>{{ $gettext('All your data is securely transmitted from you, and securely stored on, our European servers.') }}</div>
        </div>
        <div v-if="formType !== 'country'" class="signup-link-wrap">
          {{ $gettext('Already have an account?') }} <router-link data-analytics-click="signup from login" :to="{ name: 'Login', query: { ...$route.query } }" class="signup-link text-blue">{{ $gettext('Sign in') }}</router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import GkLogoAnim from "@/components/ui/GkLogoAnim"
import GekkoButton from "@/components/GekkoButton"

import SignupFormSimple from '@/components/signup/SignupFormSimple'
import SignupCountryForm from '@/components/auth/SignupCountryForm'

export default {
  name: 'SignupNew',
  components: {
    GekkoButton,
    GkLogoAnim,
    SignupFormSimple,
    SignupCountryForm
  },
  data () {
    return {
      mainTransitionKey: 0,
      rememberEmail: '',
      showCountryForm: false,
      formType: 'signup'
    }
  },
  computed: {
    ...mapGetters({ 
      isAuthenticated: 'auth/getAuthenticated',
      isNewAccount: 'signup/getSignupStatus',
      newAccountType: 'signup/getSignupType'
    }),
    sloganText () {
      return this.$gettext('Trusted by over %{ num } users')
    },
    sloganSubtext () {
      return this.$gettext('Based on <span>%{ num }</span> user reviews')
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    
  },
  methods: {
    setupData () {
      if (this.isAuthenticated) {
        console.log('Signup.vue::setupData() -> User is already logged in, redirecting to Dashboard')
        if (this.isNewAccount) {
          if (this.newAccountType === 'accountant') {
            // TODO redirect to accountants portal
            this.$router.push({ name: 'Ledger', query: { welcome: 'yes' }  }).catch(() => {})
          } else {
            // window.location.href = Urls["gekko_dashboard"]() + "?welcome=yes"
            this.$router.push({ name: 'Dashboard', query: { welcome: 'yes', ...this.$route.query }  }).catch(() => {})
          }
        } else {
          // window.location.href = Urls["gekko_dashboard"]()
          this.$router.push({ name: 'Dashboard', query: { ...this.$route.query } }).catch(() => {})
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .signup-login-form-wrap {
    .gk-clear-form {
      .form-control, .custom-select {
        border: 1px solid #dfdfdf;
        box-shadow: none;
        font-family: 'Campton-Book';
        height: 44px;
        padding: 0.5rem 1rem;
        transition: all 0.3s ease;
        background-color: white !important;
        &:focus { box-shadow: none; }
        #placeholder {
        }
      }
      .form-control {
        background-image: none;
      }
      .form-group {
        transition: all 0.3s ease;
        .input-check {
          transition: all 0.3s ease;
          position: absolute;
          top: 50%;
          left: 1rem;
          transform: translateY(-50%);
          opacity: 0;
          color: $colorBrand;
          font-size: 18px;
        }
        &.accepted {
          .form-control {
            background-color: #f5f5f5 !important;
            padding-left: 40px;
          }
          .input-check {
            opacity: 1;
          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .signup-login-wrapper {
    max-width: 540px;
    width: 540px;
    .ratings-wrap {
      padding-top: 1rem;
      padding-bottom: 2rem;
      text-align: center;
      h2 {
        font-family: 'Campton-Book';
        font-size: 30px;
        color: white;
        text-transform: uppercase;
        margin: 0 auto;
        padding-bottom: 0.5rem;
      }
      .ratings-container {
        margin-bottom: 0.5rem;
      }
      .ratings-footer {
        color: #89e4cc;
        span { font-weight: bold; }
      }
    }
  }
</style>